import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_POSITION_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class Position extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-jabatan');
  }

  render() {
    const { handleGetPosition } = this.props;
    return (
      <div className="position">
        <Button
          title="Tambah Surat Jabatan"
          onClick={this.onClickAdd}
        />
        <div className="position__content">
          <ContentTable
            onSearchContent={handleGetPosition}
            tableFields={PERSONAL_POSITION_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
Position.propTypes = {
  handleGetPosition: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Position.defaultProps = {
  handleGetPosition: noop,
};
